// Generated from products/analytics/shared/custom/aliveByMistake/summaries.ts; run analytics generate:site-runtime.
import { z } from "zod";
import {
  AliveByMistakeContextSchema,
  AliveByMistakeCountSchema,
  AliveByMistakeKeySchema,
} from "./context.gen";

export const AliveByMistakeSummaryPayloadSchema = z.strictObject({
  context: AliveByMistakeContextSchema,
  interval: AliveByMistakeCountSchema,
  activeMs: z.number().int().min(0).max(60000),
  playerKills: AliveByMistakeCountSchema,
  turretKills: AliveByMistakeCountSchema,
  damageTaken: z.number().nonnegative(),
  reloads: AliveByMistakeCountSchema,
  cashEarned: AliveByMistakeCountSchema,
  cashSpent: AliveByMistakeCountSchema,
  goldEarned: AliveByMistakeCountSchema,
  goldSpent: AliveByMistakeCountSchema,
  weaponUse: z
    .array(
      z.strictObject({
        weaponId: AliveByMistakeKeySchema,
        activeMs: AliveByMistakeCountSchema,
      }),
    )
    .max(16),
});
export type AliveByMistakeSummaryPayload = z.infer<typeof AliveByMistakeSummaryPayloadSchema>;
